import React from 'react';
import { defineCustomElements } from '@innomotics/innomotics-build-react-lib';
import 'rc-slider/assets/index.css';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import './css/styles.css';
import routes from './routes';
import { hooks } from './ts/hooks';
import { HookProvider } from './ts/providers';
import { store } from './ts/store/store';

declare global {
    interface Window {
        trackingHelper?: any;
    }
}

// AI generated code to fix keyboard enter events
(() => {
    const w = window as any;
    w.trackingHelper = w.trackingHelper ?? {};

    if (!Array.isArray(w.trackingHelper.keybord_control_tracking)) {
        w.trackingHelper.keybord_control_tracking = [];
    }

    if (!Array.isArray(w.trackingHelper.keyboard_control_tracking)) {
        w.trackingHelper.keyboard_control_tracking = w.trackingHelper.keybord_control_tracking;
    }
})();

defineCustomElements();

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <Provider store={store}>
        <HookProvider hooks={hooks}>
            <BrowserRouter>
                {routes}
            </BrowserRouter>
        </HookProvider>
    </Provider>
);
